/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.1.0
 */

import { IGTMOperation } from './index';

export enum EGTMWidgetCostsArrowType {
    left = 'Left',
    right = 'Right',
}

export const clickArrowWidgetCosts = (arrowType: EGTMWidgetCostsArrowType, date: string): IGTMOperation =>
    ({
        'event': 'addEvents_makeActions',
        'event_id': 'd-v217-e11',
        'event_cat': 'Расходы',
        'event_name': 'clickElement',
        'event_param': `${date} / ${arrowType}`,
    });

export const clickLinkAllCostsWidgetCosts = (date: string): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v217-e12',
    'event_cat': 'Расходы',
    'event_name': 'clickElement',
    'event_param': `${date} / Все расходы`,
});

